import {INITIAL_SERVER_DATA, SET_URL_PARAMS} from "../../actions/actionTypes";

export function staticDataReducer(state, action) {
    state = (state || {});
    state = state || {};
    switch (action.type) {
        case INITIAL_SERVER_DATA:
            if (window.Farmigo) {
                return Object.assign({}, state, window.Farmigo.serverData);
            } else {
                return Object.assign({}, state, {
                    logoUrl: "",
                    customBackgroundColor: "",
                    webSiteUrl: "",
                    farmUrl: "",
                    farmKey: "",
                    termsUrl: "",
                    farmName: "",
                    facebookAppId: "",
                    isSupportGuestMembers: false,
                    isSupportSalesTax: true,
                    allowUpdateVacation: false,
                    allowWebOrdersForFutureDate: false,
                    pickupSiteLabel: 'pick-up site',
                    country: 'US'
                });
            }
        case SET_URL_PARAMS:
            return Object.assign({}, state, {params: action.params});
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/common/staticDataReducer.js